import { fetchFromObject } from 'helpers/object';
import { OFFER_STATUS } from 'store/enums';

export default {
  getOfferField: state => field => fetchFromObject(state, field),
  isStatusCookieKO: state => state.statusCookie === OFFER_STATUS.KO,
  hasOffer: state => !!state.offer,
  hasOfferDetail: state => !!state.offerDetail,
  getParamsToBBVARedirect: state =>
    `/${state.idOffer}/${state.partnerId}${state.idc > 0 ? `/${state.idc}` : ''}`
};
